import Breakpoints from 'breakpoints-js/src/breakpoints';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import logger from '../utils/rbata.logger';

const categoryPromo = {
    component:         '.cms-categorypromo__component',
    targetSelector:    '.landing-page',
    sessionStorageKey: 'PromoAnimationDone',
    sliderSelector:    '.js-categorypromo-carousel',
    $sliderContainer:  undefined,
    $sliderNavigation: undefined,
    slider:            undefined,
    animate() {
        const target = document.querySelector(this.targetSelector);
        if (!target) {
            return;
        }
        setTimeout(() => {
            $('html, body').animate({scrollTop: 200}, 900, 'swing', () => {
                setTimeout(() => {
                    $('html, body').animate({scrollTop: 0}, 900, 'swing')
                }, 200)
                sessionStorage.setItem(this.sessionStorageKey, 'true');
            });
        }, 500);
    },
    init() {
        this.$sliderContainer  = $(this.sliderSelector);
        this.$sliderNavigation = this.$sliderContainer.next('nav');
        this.buildSlider();
    },
    buildSlider() {
        if (this.$sliderContainer.find(this.component).length > 1) {
            this.slider = tns({
                container:            this.$sliderContainer[0],
                mode:                 'gallery', //gallery, carousel
                items:                1,
                slideBy:              1,
                loop:                 true,
                controls:             true,
                controlsContainer:    this.$sliderNavigation[0],
                nav:                  true,
                navPosition:          'bottom',
                arrowKeys:            true,
                speed:                alphatauri.config.sliderCategoryPromoSpeed,
                autoplay:             alphatauri.config.sliderCategoryPromoAutoplay,
                autoplayHoverPause:   false,
                autoplayTimeout:      alphatauri.config.sliderCategoryPromoAutoplayTimeout,
                autoplayButton:       false,
                autoplayButtonOutput: false,
                lazyload:             false,
                mouseDrag:            false,
                onInit:               () => {
                    this.$sliderNavigation.removeClass('d-none');
                    // attribute causes issue on cloned slides
                    this.$sliderContainer.find('.cms-categorypromo__image').removeAttr('animated');
                    // stop all videos except the first one
                    this.$sliderContainer
                        .find('.cms-categorypromo__component-media')
                        .slice(1)
                        .find('.cms-categorypromo__video')
                        .removeAttr('autoplay');
                    this.$sliderContainer.removeClass('categorypromo-carousel--not-initialized');
                    mediaLazyLoad.refreshLazyLoad();
                },
            });
            this.slider.events.on('indexChanged', (info) => {
                const prevSlide    = info.slideItems[info.indexCached];
                const currentSlide = info.slideItems[info.index];
                const isPrevVideo  = $(prevSlide).find('.cms-categorypromo__video')[0];
                if (isPrevVideo) {
                    isPrevVideo.pause();
                }
                const isCurrentVideo = $(currentSlide).find('.cms-categorypromo__video')[0];
                if (isCurrentVideo) {
                    isCurrentVideo.currentTime = 0;
                    const playPromise          = isCurrentVideo.play();
                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                                       logger.log('Current video is playing');
                                   })
                                   .catch(() => {
                                       logger.log('Error on playing current video');
                                   });
                    }
                }
            });
        }
    },
}

$(() => {
    if (document.querySelector(categoryPromo.component) && Breakpoints.is('desktop') && !sessionStorage.getItem(categoryPromo.sessionStorageKey)) {
        categoryPromo.animate();
    }
    if (document.querySelector(categoryPromo.sliderSelector)) {
        categoryPromo.init();
    }
});

export default categoryPromo;